import React, { useEffect } from "react";
import Loading from "./Loading";
import { ReactComponent as Check } from "../img/checkbox-circle-fill.svg";
import { ReactComponent as Cross } from "../img/close-circle-fill.svg";

function Alert({
  pendingTransaction,
  transactionStatus,
  removeTransaction,
}: {
  pendingTransaction: string;
  transactionStatus: any;
  removeTransaction: Function;
}) {
  useEffect(() => {
    if (
      transactionStatus === "ACCEPTED_ONCHAIN" ||
      transactionStatus === "PENDING" ||
      transactionStatus === "REJECTED"
    ) {
      setTimeout(removeTransaction, 5000);
    }
  }, [transactionStatus, removeTransaction]);

  return (
    <div className="max-w-max ml-auto px-2 sm:px-4 mb-4">
      <div className="p-2 rounded-sm bg-transparent border border-white shadow-lg sm:p-3">
        <div className="flex items-center justify-between flex-wrap">
          <div className="flex-1 flex items-center mr-6">
            {transactionStatus === "ACCEPTED_ONCHAIN" ||
            transactionStatus === "PENDING" ? (
              <Check />
            ) : transactionStatus === "REJECTED" ? (
              <Cross />
            ) : (
              <Loading />
            )}
            <p className="ml-2 font-medium text-white truncate">
              {transactionStatus === "PENDING" ||
              transactionStatus === "ACCEPTED_ONCHAIN"
                ? "Accepted"
                : transactionStatus === "REJECTED"
                ? "Rejected"
                : "Pending"}
            </p>
          </div>
          <div className="order-3 mt-2 flex-shrink-0 w-full sm:order-2 sm:mt-0 sm:w-auto">
            <div className="rounded-sm shadow-sm pointer-events-auto">
              <a
                target="_blank"
                rel="noreferrer"
                href={`https://voyager.online/tx/${pendingTransaction}`}
                className="flex items-center justify-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-sm text-white bg-transparent hover:text-black hover:bg-white border-white focus:outline-none focus:underline"
              >
                Voyager ↗
              </a>
            </div>
          </div>
          {/* <div className="order-2 flex-shrink-0 sm:order-3 sm:ml-2">
            <button
              type="button"
              className="-mr-1 flex p-2 rounded-sm hover:bg-white focus:text-black focus:outline-none focus:bg-white text-white hover:text-black"
              aria-label="Hide banner"
            >
              <svg
                className="h-6 w-6"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default Alert;
